videojs.addLanguage('en', {
  "AddCaptureButton": "Add a thumbnail",
  "AddChapterButton": "Add a chapter",
  "AddImageButton": "Add an image",
  "index": "Index",
  "AddQuestionButton": "Add a question",
  "AddQuizButton": "Add a quiz",
  "AddSondageButton": "Add a survey",
  "AddAnnotationButton": "Add an annotation",
  "slide": "Slide",
  "AddVideoButton": "Add a video",
  "SaveButton": "Save",
  "chapter": "Chapter",
  "image": "Image",
  "question": "Question",
  "quiz": "Quiz",
  "hidden-area": "Hidden Area",
  "CTAButton": "Call to action",
  "AddHiddenAreaButton": "Add a hidden area",
  "PreviewButton": "Preview"
});


//////////////////
// WEBPACK FOOTER
// ./plugin/videojs_ultimate/dist/lang/en.js
// module id = 972
// module chunks = 0